import React from "react";
import { withStyles } from "@material-ui/styles";

import colors from "../../../assets/style/colors";
import { Dialog } from "@material-ui/core";
import { DialogTitle } from "@material-ui/core";
import CloseIcon from "../../Common/CloseIcon";
import { I18n } from "@aws-amplify/core";
import { Button } from "@material-ui/core";
import { connect } from "react-redux";
import FormSection from "../../Common/FormSection";
import { map, filter, flatten } from "lodash";

import { get } from "lodash";
import "./date.css";

const styles = (theme) => ({
    dialog: {
        maxWidth: "300px",
    },
    title: {
        textTransform: "uppercase",
        color: "black",
        fontWeight: 500,
    },
    radioGroup: {
        flexDirection: "row",
    },
    formControlRoot: {
        marginRight: "24px",
    },
    plusIcon: {
        cursor: "pointer",
        display: "flex",
        alignItems: "center",
    },
    notchedOutline: {
        borderWidth: "1px",
        borderColor: "red !important"
    },
    greenOutline: {
        borderWidth: "1px",
        borderColor: "green !important"
    },
    select: {
        paddingTop: 0,
        paddingBottom: 0,
        height: "40px",
        fontSize: "0.875em",
    },
    input: {
        height: "40px",
    },
    dialogTitle: {
        fontSize: "1.142em",
        color: colors.black87,
        textAlign: "center",
        textTransform: "uppercase",
    },
    close: {
        background: "none",
        '&:hover': {
            background: "blue",
        },
    },
    closeIcon: {
        display: "flex",
        justifyContent: "flex-end",
    },
    dialogPaper: {
        minWidth: '514px',
        minHeight: '284px',
    },
});


const TimeZone = (props) => {
    const { classes, setOpen, timeSelectedParent, site, zoneSelectedParent, zone, master_date } = props;
    const [time, changeTime] = React.useState(new Date(master_date));
    const [view, changeView] = React.useState('1');
    const [current_zone, changeZone] = React.useState(zone);

    const activeSite = get(
        filter(
            flatten(map(props.companies, (c) => c.sites)),
            (s) => s.id === site
        ),
        [0]
    );
    const zones = filter(
        get(activeSite, ["zones"]),
        (z) =>
            z.active &&
            z.is_human_access &&
            (get(props, ["eventGroupType", "id"]) === 4
                ? z.is_entrance
                : get(props, ["eventGroupType", "id"]) === 5
                    ? z.is_exit
                    : true)
    );

    const handleChangeRadio = (e) => {
        changeView(e.target.value)
    }

    const handleZoneChange = (e) => {
        changeZone(e)
    }

    const handleClose = () => {
        setOpen(false);
    };

    return (
        <div>
            <Dialog open={true} onClose={handleClose} classes={{ paper: classes.dialogPaper }}>
                <DialogTitle style={{ position: "relative", textAlign: "center" }}>
                    <span style={{ fontSize: "16px", color: colors.black87, fontWeight: 500 }}>{I18n.get("profiles_zone")}</span>
                </DialogTitle>
                <CloseIcon closeFunction={handleClose} style={{ position: "relative", top: "-50px", left: "440px" }} />
                <div>
                    <div style={{ position: "relative", width: 220, top: -15, marginLeft: "160px" }}>
                        <FormSection
                            formValue={[current_zone]}
                            setFormValue={(id, index, value) =>
                                handleZoneChange(value)
                            }
                            title={"zone"}
                            id={"zone"}
                            type="select"
                            options={{
                                comboBox: true,
                                required: true,
                                options: map(zones, (z) => ({
                                    id: z.id,
                                    name: z.name,
                                })),
                            }}
                            style={{ maxWidth: "320px" }}
                        />
                    </div>
                </div>

                <div style={{ position: "relative", marginLeft: "160px", height: 0 }}>
                    <Button
                        onClick={handleClose}
                        color="primary"
                        style={{ marginRight: "20px" }}
                        id="cancel"
                    >
                        {I18n.get("site_cancel")}
                    </Button>
                    <Button
                        onClick={() => {
                            zoneSelectedParent(current_zone)
                            setOpen(false)
                        }}
                        color="primary" F
                        variant="contained"
                        id="confirm"
                    >
                        {I18n.get("site_confirm")}
                    </Button>
                </div>


            </Dialog>
        </div>
    );
};

const mapStateToProps = (state) => {
    return {
        companies: get(state, ["user", "companies"]),
    };
};

export default connect(mapStateToProps)(withStyles(styles)(TimeZone));
